import {setupModal} from './modal';
import {openModal} from './modal';

// настраиваем модалки тут, все колбеки импортим, а не создаем из этого модуля простыню
const initModal = (modalId, modal, btn) => {
  switch (modalId) {
    case 'example':
      setupModal(modal, false, btn, false, true, true);
      break;

    case 'profile':
      setupModal(modal);
      const modalBtns = document.querySelectorAll('[data-modal="profile"]');

      if (modalBtns.length) {
        modalBtns.forEach((modalButton) => {
          modalButton.addEventListener('click', (evt) => {
            const breakpoint = window.matchMedia('(max-width:1023px)');
            if (breakpoint.matches) {
              evt.preventDefault();
              openModal(modal);
            }
          });
        });
      }
      break;

    default:
      setupModal(modal, false, btn, false, false, false);
      break;
  }
};

// аргументы setupModal(modal, closeCallback, modalBtns, openCallback, noPrevDefault, preventScrollLock)
// возможна инициализация только с первыми аргументом,
// если вам нужно открывать модалку в другом месте под какими-нибудь условиями
const initModals = () => {
  const modals = document.querySelectorAll('.modal:not(.is-initialized)');
  const modalBtns = document.querySelectorAll('[data-modal]');

  // фикс для редких случаев, когда модалка появляется при загрузке страницы
  if (modals.length) {
    modals.forEach((el) => {
      setTimeout(() => {
        el.classList.remove('modal--preload');
        el.classList.add('is-initialized');
      }, 100);
    });
  }

  if (modalBtns.length) {
    modalBtns.forEach((btn) => {
      const modalId = btn.dataset.modal;
      const modal = document.querySelector(`.modal--${modalId}`);
      if (modal) {
        initModal(modalId, modal, btn);
      }
    });
  }
};

window.initModals = initModals;

export {initModals};
